/* je-ghost-card-fix-20260901 - register the fallback feather to the PHOTOGRAPH.
   A poster card whose cut-out asset is missing falls back to the raw studio
   photo and wears `.je-cutout-fallback`, whose two-axis mask melts the white
   sweep.  That mask is resolved against the IMG's border box, but the picture
   inside it is `object-fit: contain` inside `padding: 10% 11% 17%`, so on most
   photographs the fade runs out in the padding and the sweep still ends in a
   hard line (measured 116 and 234 luminance levels on the live AtO page).

   This publishes the picture's own rect as --je-fb-x/y/w/h and the stylesheet
   positions and sizes the mask from them.  Nothing here paints; if it never
   runs the CSS falls back to `0px 0px / 100% 100%`, i.e. exactly the mask that
   is live today. */
(function () {
  var SEL = 'img.je-cutout-fallback';
  var pending = false;
  var queued = [];
  var bound = [];
  var ro = null;

  function measure(img) {
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return;
    var bw = img.clientWidth, bh = img.clientHeight;
    if (!bw || !bh) return;
    var s = getComputedStyle(img);
    var pl = parseFloat(s.paddingLeft) || 0, pr = parseFloat(s.paddingRight) || 0;
    var pt = parseFloat(s.paddingTop) || 0, pb = parseFloat(s.paddingBottom) || 0;
    var cw = bw - pl - pr, ch = bh - pt - pb;
    if (cw <= 0 || ch <= 0) return;
    /* the card's own contract: object-fit:contain + object-position:50% 100% */
    var k = Math.min(cw / nw, ch / nh);
    var dw = nw * k, dh = nh * k;
    var x = pl + (cw - dw) * 0.5;
    var y = pt + (ch - dh);
    return [x.toFixed(2) + 'px', y.toFixed(2) + 'px', dw.toFixed(2) + 'px', dh.toFixed(2) + 'px'];
  }

  function paint(img, values) {
    if (!values) return;
    var props = ['--je-fb-x', '--je-fb-y', '--je-fb-w', '--je-fb-h'];
    for (var i = 0; i < props.length; i++) {
      if (img.style.getPropertyValue(props[i]) !== values[i]) img.style.setProperty(props[i], values[i]);
    }
  }
  function place(img) { paint(img, measure(img)); }

  function flush() {
    pending = false;
    var list = queued; queued = [];
    // Read every affected rectangle before changing any mask variables.
    var values = list.map(function (img) {
      return img.isConnected && img.matches(SEL) && img.complete ? measure(img) : null;
    });
    for (var i = 0; i < list.length; i++) paint(list[i], values[i]);
  }
  function enqueue(img) {
    if (bound.indexOf(img) < 0) bound.push(img);
    if (!img.__jeFb) {
      img.__jeFb = 1;
      img.addEventListener('load', function () { place(this); });
    }
    if (ro && !img.__jeFbObserved) {
      try { ro.observe(img); img.__jeFbObserved = true; } catch (e) {}
    }
    if (queued.indexOf(img) < 0) queued.push(img);
    if (!pending) { pending = true; requestAnimationFrame(flush); }
  }
  function collect(node) {
    if (!node || (node.nodeType !== 1 && node.nodeType !== 9)) return;
    if (node.matches && node.matches(SEL)) enqueue(node);
    var list = node.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) enqueue(list[i]);
  }
  function schedule() { collect(document); }
  function detach(node) {
    if (!ro || !node || node.nodeType !== 1 || node.isConnected) return;
    var list = node.matches('img') ? [node] : node.querySelectorAll('img');
    for (var i = 0; i < list.length; i++) {
      if (list[i].__jeFbObserved) { ro.unobserve(list[i]); list[i].__jeFbObserved = false; }
    }
  }
  function hasStyles(node) {
    return node.nodeType === 1 && (node.matches('style,link[rel="stylesheet"]') || node.querySelector('style,link[rel="stylesheet"]'));
  }
  function changed(records) {
    var styles = false;
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'attributes') {
        // Existing images can become fallbacks; ancestor classes can alter padding.
        if (r.target.matches(SEL)) enqueue(r.target);
        else if (r.attributeName === 'class') {
          for (var j = 0; j < bound.length; j++) {
            if (bound[j].isConnected && bound[j].matches(SEL) && r.target.contains(bound[j])) enqueue(bound[j]);
          }
        }
        continue;
      }
      // A badge/child removal can change an existing image's padding through
      // structural CSS without changing its observed box. Revisit bound images
      // within that changed subtree, without searching the document again.
      for (var j = 0; j < bound.length; j++) {
        if (bound[j].isConnected && bound[j].matches(SEL) && r.target.contains(bound[j])) enqueue(bound[j]);
      }
      if (r.target.nodeType === 1 && r.target.tagName === 'STYLE') styles = true;
      for (var j = 0; j < r.addedNodes.length; j++) {
        collect(r.addedNodes[j]);
        if (hasStyles(r.addedNodes[j])) styles = true;
      }
      for (var j = 0; j < r.removedNodes.length; j++) {
        if (hasStyles(r.removedNodes[j])) styles = true;
        detach(r.removedNodes[j]);
      }
    }
    bound = bound.filter(function (img) { return img.isConnected; });
    if (styles) schedule();
  }

  if (window.ResizeObserver) {
    ro = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) place(entries[i].target);
    });
  }

  /* The AtO grid, the In Stock grid and the Deals grid all re-render client
     side (filter, sort, Load more), so a one-shot pass would cover the first
     paint only.  Only affected additions are discovered; load, class, stylesheet and resize
     changes retain the same geometry updates. je-feather-targeted-20261020. */
  /* ⚠️ observe a node that is guaranteed to exist.  `document.documentElement`
     is null if this ever runs before the document has a root - which a deferred
     <script> in <head> never does, but a QA harness injecting at
     `addInitScript` time does, and it threw there.  A guard is cheaper than a
     rule about how it may be loaded. */
  var root = document.documentElement || document;
  if (window.MutationObserver && root) {
    new MutationObserver(changed).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src', 'srcset', 'sizes'] });
  }
  document.addEventListener('load', function (event) {
    if (event.target.matches && event.target.matches('link[rel="stylesheet"]')) schedule();
  }, true);
  window.addEventListener('resize', schedule, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  schedule();
})();
